import * as React from 'react'
import type { SVGProps } from 'react'
const SvgUser = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.458 6.25a3.542 3.542 0 1 1 7.084 0 3.542 3.542 0 0 1-7.084 0M10 3.958a2.292 2.292 0 1 0 0 4.584 2.292 2.292 0 0 0 0-4.584M6.667 12.292c-1.036 0-1.875.84-1.875 1.875v.99c0 .015.01.028.025.03 3.433.56 6.933.56 10.365 0a.03.03 0 0 0 .026-.03v-.99c0-1.036-.84-1.875-1.875-1.875h-.284a.2.2 0 0 0-.064.01l-.722.235c-1.47.48-3.056.48-4.526 0l-.722-.235a.2.2 0 0 0-.064-.01zm-3.125 1.875c0-1.726 1.399-3.125 3.125-3.125h.284q.231 0 .452.072l.722.235a6.04 6.04 0 0 0 3.75 0l.722-.235q.22-.072.452-.072h.284c1.726 0 3.125 1.399 3.125 3.125v.99a1.28 1.28 0 0 1-1.074 1.264 33.4 33.4 0 0 1-10.768 0 1.28 1.28 0 0 1-1.074-1.264z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgUser
